import React from "react";
import {ActionRowDropdownButton, DropdownItem, DropdownItemGroup, DropdownItemGroups, Icon} from "peggirkit";
import {CheckIcon, FunnelIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import {CartKindFilter, cartKindFilters} from "@widgets/reports/cartTimeline/CartTimelineUtils";

type Props = {
    filter: CartKindFilter,
    setFilter: (filter: CartKindFilter) => void,
    showPos: boolean,
    setShowPos: (show: boolean) => void,
    /** Number of carts per filter, shown behind its name. */
    counts: Record<CartKindFilter, number>,
};

/**
 * Filter of the timeline and table: by status, and whether to show the
 * orders placed via the POS.
 */
const CartKindFilterButton = ({filter, setFilter, showPos, setShowPos, counts}: Props) => (
    <ActionRowDropdownButton
        showInRowBreakpoint={"sm"}
        color={"secondary"}
        iconBefore={<Icon icon={FunnelIcon}/>}
        selected={filter !== "all" || showPos}
        items={
            <DropdownItemGroups>
                <DropdownItemGroup>
                    <DropdownItem buttonAction={{as: "groupLabel", actionProps: {}}}>
                        <FormattedMessage id={"status"}/>
                    </DropdownItem>
                    {cartKindFilters.map((option: CartKindFilter) => (
                        <DropdownItem
                            key={option}
                            icon={filter === option ? <Icon icon={CheckIcon}/> : "empty"}
                            disabled={filter === option}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: () => setFilter(option),
                                },
                            }}
                        >
                            <FormattedMessage
                                id={"cartTimeline.filter.withCount"}
                                values={{
                                    name: <FormattedMessage id={`cartTimeline.filter.${option}`}/>,
                                    n: counts[option],
                                }}
                            />
                        </DropdownItem>
                    ))}
                </DropdownItemGroup>

                <DropdownItemGroup>
                    <DropdownItem
                        icon={showPos ? <Icon icon={CheckIcon}/> : "empty"}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: () => setShowPos(!showPos),
                            },
                        }}
                    >
                        <FormattedMessage id={"cartTimeline.filter.showPos"}/>
                    </DropdownItem>
                </DropdownItemGroup>
            </DropdownItemGroups>
        }
    >
        <FormattedMessage id={`cartTimeline.filter.${filter}`}/>
    </ActionRowDropdownButton>
);

export default CartKindFilterButton;